import { useCallback, useState } from 'react';
import _ from 'lodash';
import { faBusinessFront } from '@fortawesome/pro-solid-svg-icons';
import { InputSuffix, TextBox, TextBoxChangeEvent } from '@progress/kendo-react-inputs';
import { Icon } from 'components';
import styles from './CustomerFilter.module.scss'

const DELAY_MS = 1200;

type CustomerFilterProps = {
    customerId?: string,
    onCustomerIdChange: (customerId: string) => void,
};

const CustomerFilter = ({ customerId, onCustomerIdChange } : CustomerFilterProps) =>
{
    const [value, setValue] = useState<string>(customerId ?? '');

    const debouncedChangeHandler = useCallback(
        _.debounce((id: string) => onCustomerIdChange(id), DELAY_MS),
        [onCustomerIdChange]
    );
    
    const submit = (inputVal: string) => {
        const val = inputVal.trim();
        debouncedChangeHandler.cancel();
        debouncedChangeHandler(val);
    };

    const onChange = (e: TextBoxChangeEvent) => {
        const val = e.value?.toString() ?? '';
        setValue(val)
        submit(val);
    };

    return <TextBox
        suffix={()=> <InputSuffix><Icon icon={faBusinessFront}/></InputSuffix>}
        className={styles.input}
        placeholder='Customer ID'
        onChange={onChange}
        value={value}
    />;
}

export default CustomerFilter;